import { NFTCardProps } from "../types";

export default function NFTCard(props: NFTCardProps): JSX.Element {
  return (
    <div
      className="flex flex-col p-4 cursor-pointer border-2 rounded-lg border-gray-200 dark:border-gray-700 max-w-[300px]"
      onClick={props.onClick}
    >
      <span className="text-xl font-bold mt-2">NFT #{props.data.tokenId}</span>
      <div className="flex justify-center items-center max-w-full max-h-[200px] min-w-[180px] min-h-[180px] overflow-hidden hover:opacity-80">
        {props.data.external_image ? (
          <img src={props.data.external_image} alt="" className="mt-2" />
        ) : (
          <img src="" alt="No Asset" className="mt-2" />
        )}
      </div>
      <ul className="text-sm mt-2">
        <li>
          <p>Token URI: </p>
          <p className="text-[4px] dark:text-blue-200 break-words">
            {props.data.tokenURI}
          </p>
        </li>
        {props.data.metadata_json && (
          <>
            <li>
              <p>Name: </p>
              <p className="text-[4px] dark:text-blue-200 break-words">
                {props.data.metadata_json.name}
              </p>
            </li>
            <li>
              <p>Desc: </p>
              <p className="text-[4px] dark:text-blue-200 break-words">
                {props.data.metadata_json.description}
              </p>
            </li>
          </>
        )}
        <li>
          <p>Transaction: </p>
          <p className="text-[4px] dark:text-blue-200 break-words">
            {props.data.log.log.transactionHash}
          </p>
        </li>
      </ul>
    </div>
  );
}
